var render, staticRenderFns
import script from "./HasEditableChildren.vue?vue&type=script&lang=js&"
export * from "./HasEditableChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports